export const MAP_KIND = "map";

export function isMapDefinition(def: { kind?: string } | null | undefined): boolean {
  return def?.kind === MAP_KIND;
}

/** The map product has its own page, not /design/<id> or /canvas/<id>. */
export function mapPageHref(locale: string): string {
  return `/${locale}/zemljevid`;
}

export function showDefinitionInMenu(
  def: { kind?: string },
  flags: { mapsEnabled: boolean },
): boolean {
  return !isMapDefinition(def) || flags.mapsEnabled;
}
